import { defineAsyncComponent } from 'vue';
import { DUO_CHAT_QUICK_ACTION_SUMMARIZE, DUO_CHAT_AGENT_PLANNER } from '~/ai/constants';
import { s__ } from '~/locale';
import glLicensedFeaturesMixin from '~/vue_shared/mixins/gl_licensed_features_mixin';
import glAbilitiesMixin from '~/vue_shared/mixins/gl_abilities_mixin';
import DiscussionFilter from './discussion_filter.vue';
export default {
    name: 'NotesActivityHeader',
    components: {
        TimelineToggle: defineAsyncComponent(()=>import('./timeline_toggle.vue')),
        DiscussionFilter,
        DuoChatQuickAction: defineAsyncComponent(()=>import('ee_component/ai/shared/widgets/duo_chat_quick_action.vue')),
        MrDiscussionFilter: defineAsyncComponent(()=>import('./mr_discussion_filter.vue'))
    },
    mixins: [
        glAbilitiesMixin(),
        glLicensedFeaturesMixin()
    ],
    inject: {
        showTimelineViewToggle: {
            default: false
        },
        resourceGlobalId: {
            default: null
        },
        mrFilter: {
            default: false
        }
    },
    props: {
        notesFilters: {
            type: Array,
            required: true
        },
        notesFilterValue: {
            type: Number,
            default: undefined,
            required: false
        },
        noteableType: {
            type: String,
            default: '',
            required: false
        }
    },
    computed: {
        summarizeTracking () {
            return {
                label: 'issue_view_summary',
                property: this.noteableType
            };
        },
        showAiActions () {
            return this.resourceGlobalId && this.glAbilities.summarizeComments && this.glLicensedFeatures.summarizeComments;
        }
    },
    buttonOptions: {
        size: 'small'
    },
    classicQuickAction: DUO_CHAT_QUICK_ACTION_SUMMARIZE,
    summarizeCommand: {
        agent: {
            name: DUO_CHAT_AGENT_PLANNER
        },
        agenticPrompt: s__('AI|Summarize the comments on this issue.')
    }
};
